module.exports = __webpack_public_path__ + "static/media/btn_contact_close.ea0fe3e0.svg";